import { Facebook, Film, Instagram, Youtube } from "lucide-react";
import { FACEBOOK, IMDB, INSTAGRAM, YOUTUBE } from "@/data/content";
import { Logo } from "./Logo";

const SOCIALS = [
  { id: "instagram", href: INSTAGRAM, Icon: Instagram, label: "Instagram" },
  { id: "facebook", href: FACEBOOK, Icon: Facebook, label: "Facebook" },
  { id: "youtube", href: YOUTUBE, Icon: Youtube, label: "YouTube" },
  { id: "imdb", href: IMDB, Icon: Film, label: "IMDb" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--ink)] text-[var(--bg)] pt-20 pb-10 px-5 sm:px-10">
    <div className="max-w-[1500px] mx-auto">
      <div className="flex flex-col sm:flex-row justify-between gap-8 mb-16">
        <Logo className="w-14 h-14 text-[var(--bg)]" />
        <div className="flex flex-col sm:items-end gap-3 text-sm text-stone-300">
          <div data-testid="footer-socials" className="flex items-center gap-3">
            {SOCIALS.map(({ id, href, Icon, label }) => (
              <a key={id} data-testid={`footer-${id}-link`} href={href} target="_blank" rel="noreferrer" aria-label={label} title={label}
                className="grid h-11 w-11 place-items-center rounded-full border border-white/25 text-stone-200 hover:bg-[var(--gold-soft)] hover:border-[var(--gold-soft)] hover:text-[var(--ink)] transition-colors duration-500">
                <Icon size={17} strokeWidth={1.5} />
              </a>
            ))}
          </div>
          <span className="text-stone-400">Ambassador — Reduce Inequalities Together · UN Global Goal 10</span>
        </div>
      </div>
      <p className="font-display leading-[0.8] tracking-[-0.04em] text-[20vw] sm:text-[13vw] text-[var(--bg)] whitespace-nowrap">
        Mimi <em className="text-[var(--gold-soft)]">Tao</em>
      </p>
      <div className="mt-8 flex flex-col sm:flex-row justify-between gap-2 text-xs uppercase tracking-[0.2em] text-stone-400">
        <span>© 2026 Mimi Tao. All rights reserved.</span>
        <span>Actress · Model · Activist</span>
      </div>
    </div>
  </footer>
);
